import { pluralize } from "@suse-o11y/pluralize";
import type { Record } from "@suse-o11y/record";
import React, { useEffect, useState } from "react";

import zeroDaysLeftImg from "../../../../../../assets/images/Component_0_days.svg";
import oneDaysLeftImg from "../../../../../../assets/images/Component_1_days.svg";
import twoDaysLeftImg from "../../../../../../assets/images/Component_2_days.svg";
import threeDaysLeftImg from "../../../../../../assets/images/Component_3_days.svg";
import fourDaysLeftImg from "../../../../../../assets/images/Component_4_days.svg";
import fiveDaysLeftImg from "../../../../../../assets/images/Component_5_days.svg";
import sixDaysLeftImg from "../../../../../../assets/images/Component_6_days.svg";
import sevenDaysLeftImg from "../../../../../../assets/images/Component_7_days.svg";
import { queryLicenseConfig } from "../../../../queries";
import { useQuery } from "../../../../queries/react-query";
import { TRIAL_LINK } from "../../docLink/AllDocLinkSlugs";
import { isAboutToExpire } from "../is-about-to-expire";

import { ExpirationModal } from "./ExpirationModal";

const imgMap: Record<number, string> = {
	0: zeroDaysLeftImg,
	1: oneDaysLeftImg,
	2: twoDaysLeftImg,
	3: threeDaysLeftImg,
	4: fourDaysLeftImg,
	5: fiveDaysLeftImg,
	6: sixDaysLeftImg,
	7: sevenDaysLeftImg,
};

const pluralizeDays = pluralize({
	1: "1 day",
	more: (count) => `${count} days`,
});

export const TrialExpiration: React.FC = () => {
	const [showModal, setShowModal] = useState(false);

	const { data } = useQuery(queryLicenseConfig);

	// Show the warning again after the license info is refetched, even if the user previously dismissed it
	useEffect(() => {
		if (data != null) {
			const isExpiring = data.error == null && isAboutToExpire(data.daysLeftToExpire);
			setShowModal(data.isTrial && isExpiring);
		}
	}, [data]);

	const contactSales = () => open(TRIAL_LINK, "_blank");

	if (showModal && data != null) {
		return (
			<ExpirationModal
				applyForLicense={contactSales}
				bodyContent="Please contact us to keep using your trial instance and one of our experts will reach back to you."
				cancelButton
				closable={true}
				daysLeftImage={imgMap[data.daysLeftToExpire]}
				headerText={`Your subscription has ${pluralizeDays(data.daysLeftToExpire)} left!`}
				onCancel={() => setShowModal(false)}
				visible
			/>
		);
	}

	return null;
};
